<template>
  <v-app id="login" class="primary">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/static/logo/fg-logo.svg"
                    alt="FG Payment"
                    width="120"
                    height="120"
                  />
                  <h2 class="flex my-4 primary--text">
                    {{ $t("forgotPassword.title") }}
                  </h2>
                  <lang-select></lang-select>
                </div>
                <v-form name="loginForm" ref="loginForm" :model="loginForm">
                  <v-text-field
                    autocomplete
                    append-icon="person"
                    name="email"
                    :label="$t('common.email')"
                    type="text"
                    v-model="loginForm.email"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
              <router-link to="login">{{
                  $t("forgotPassword.goBackLogin")
                  }}</router-link>
                <v-spacer></v-spacer>
                <v-btn width="200" color="primary" @click="login" :loading="loading"
                  >{{ $t("forgotPassword.sendResetLink") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-snackbar
            :timeout="3000"
            :bottom="snackbar.y === 'bottom'"
            :top="snackbar.y === 'top'"
            :multi-line="snackbar.mode === 'multi-line'"
            right
            :color="snackbar.color"
            v-model="snackbar.show"
          >
            {{ snackbar.text }}
            <v-btn dark text @click.native="snackbar.show = false" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { validateEmail } from "@/util/validate";
import LangSelect from "@/components/LangSelect";

export default {
  name: "Login",
  components: {
    LangSelect
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      if (!validateEmail(value)) {
        callback(new Error("Please enter the correct email"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      loginForm: {
        email: "",
        redirectUrl:
          window.location.origin + window.location.pathname + "#/reset-password"
      },
      loginRules: {
        email: [{ required: true, trigger: "blur", validator: checkEmail }]
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  methods: {
    login() {
      this.loading = true;

      this.$store
        .dispatch("sendResetPassword", this.loginForm)
        .then(() => {
          this.loading = false;
          let email = this.loginForm.email;
          this.loginForm.email = "";
          this.snackbar = {
            show: true,
            color: "green",
            text: `A reset password e-mail has been sent to ${email}.`
          };
        })
        .catch(() => {
          this.snackbar = {
            show: true,
            color: "red",
            text: "The email is invalid."
          };
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="css">
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}

.v-card__actions .v-btn {
    margin: 0;
    min-width: 56px;
}
</style>
